export const SystemLightPalette: any = {
    0: '#FFFFFF',
    1: '#A1A3A6',
    2: '#FF8077',
    3: '#F8CD4D',
    4: '#7BD693',
    5: '#1970ff',
}

export const SystemLightBorderPalette: any = {
    0: '#FFFFFF',
    1: '#8E9197',
    2: '#E86961',
    3: '#EFC545',
    4: '#6AC782',
    5: '#0068FF',
}